import React, { useEffect, useState } from 'react'
import { TabBar, Tab } from '../../styles/TransactionHistoryStyles'
import FilterLayout from '../layouts/FilterLayout'
import Text from '../../core/utils/Text'
import useTransactions from '../../core/hooks/useTransaction'
import ModalLayout from '../layouts/ModalLayout'
import TransactionTable from './TransactionsTable'
import TransactionDetails from './TransactionDetails'
import { useWindowSize } from '../../core/hooks/useWindowSize'
import { TABLET_SIZE } from '../../core/constants/common'

export default function NewTransactionHistory({ type, flow }) {
    const { width } = useWindowSize()
    const [activeTab, setActiveTab] = useState(1)
    const [detailsModal, setDetailsModal] = useState({
        open: false,
        item: null,
    })

    const {
        bankQueries,
        bankFetching,
        bankTransactions,
        walletQueries,
        walletFetching,
        walletTransactions,
        allPages,
        setBankQueries,
        setWalletQueries,
        bankInitialState,
        walletInitialState,
    } = useTransactions()

    useEffect(() => {
        if (type === 'bank') {
            setBankQueries((prevState) => ({
                ...prevState,
                page: 1,
                query: { ...prevState.query, flow: flow },
            }))
        }
        if (type === 'wallet') {
            setWalletQueries((prevState) => ({
                ...prevState,
                page: 1,
                query: { ...prevState.query, flow: flow },
            }))
        }
    }, [type, flow])

    const onModalClosed = () => {
        setDetailsModal({ id: null, open: false })
    }

    return (
        <>
            <div className='overflow-y-auto'>
                <FilterLayout
                    // headers={type === 'bank' ? bankingHeaders : walletHeaders}
                    data={
                        type === 'bank' ? bankTransactions : walletTransactions
                    }
                    totalPages={type === 'bank' ? allPages.BT : allPages.WT}
                    // tabbar={<Tabbar />}
                    // hasTabbar
                    // hasSearchOption={activeTab === 1}
                    hasCoinOption={type === 'wallet'}
                    // hasFlowOptions
                    // hasStatusOptions
                    state={
                        type === 'bank'
                            ? {
                                filterQueries: bankQueries,
                                setFilterQueries: setBankQueries,
                                initialState: bankInitialState,
                            }
                            : {
                                filterQueries: walletQueries,
                                setFilterQueries: setWalletQueries,
                                initialState: walletInitialState,
                            }
                    }
                    activeTab={activeTab}
                    loading={type === 'bank' ? bankFetching : walletFetching}>
                    {type === 'bank' ? (
                        bankTransactions?.data?.length ? (
                            <TransactionTable
                                data={bankTransactions.data}
                                // activeTab={activeTab}
                                type={type}
                                setDetailsModal={setDetailsModal}
                            />
                        ) : null
                    ) : walletTransactions?.data?.length ? (
                        <TransactionTable
                            data={walletTransactions.data}
                            // activeTab={activeTab}
                            type={type}
                            setDetailsModal={setDetailsModal}
                        />
                    ) : null}
                </FilterLayout>
            </div>

            {detailsModal.open ? (
                <ModalLayout
                    width={width > TABLET_SIZE ? '600px' : '100%'}
                    open={detailsModal.open}
                    onClose={onModalClosed}>
                    <TransactionDetails
                        type={type}
                        transaction={detailsModal.item}
                        onClose={onModalClosed}
                    />
                </ModalLayout>
            ) : null}
        </>
    )
}

const walletHeaders = [
    { title: 'coin', width: '10%' },
    { title: 'amount', width: '10%' },
    { title: 'transactionType', width: '10%' },
    { title: 'id', width: '20%' },
    { title: 'network', width: '10%' },
    { title: 'date', width: '10%' },
    { title: 'timeHour', width: '10%' },
    { title: 'status', width: '10%' },
    { title: 'details', width: '10%' },
]

const bankingHeaders = [
    { title: 'amount', width: '15.6%' },
    { title: 'transactionType', width: '15.6%' },
    { title: 'id', width: '20.2%' },
    { title: 'date', width: '13.6%' },
    { title: 'timeHour', width: '13.6%' },
    { title: 'status', width: '13.6%' },
    { title: 'details', width: '8%' },
]
